require("./helper/index.js");
require("./page/product/index.js");
require("./page/salepages/index.js");
require("./page/shop/index.js");
require("./page/user/index.js");
require("./page/test/index.js");
require("./page/package/index.js");
require("./page/form/index.js");
require("./page/transport");
require("./page/payment/index.js");
require("./page/checkout/index.js");
require("./page/stock/index.js");
require("./page/order/index.js");
require("./page/guide_salepage/index.js");
require("./page/category/index.js");
require("./page/menu-format/index.js");
require("./page/menu/index.js");


// Sale page component
Vue.component(
    "create-salepage-component",
    require("./page/salepages/Create.vue").default
);
Vue.component(
    "edit-salepage-component",
    require("./page/salepages/Edit.vue").default
);
Vue.component(
    "delete-salepage-component",
    require("./page/salepages/Delete.vue").default
);
Vue.component(
    "manage-salepage-component",
    require("./page/salepages/Manage.vue").default
);
Vue.component(
    "data-salepage-component",
    require("./page/salepages/_data.vue").default
);
Vue.component(
    "modal-data-salepage-component",
    require("./page/salepages/_modal_add_data.vue").default
);
Vue.component(
    "flash-sale-component",
    require("./page/salepages/FlashSale.vue").default
);
Vue.component(
    "background-setting-component",
    require("./page/salepages/Background.vue").default
);
Vue.component("token-component", require("./page/salepages/Token.vue").default);
Vue.component(
    "edit-salepage-body-component",
    require("./page/salepages/EditSalePageBody.vue").default
);
Vue.component(
    "toggle-component",
    require("./page/salepages/Toggle.vue").default
);

Vue.component(
    "domain-verification-component",
    require("./page/salepages/DomainVerification.vue").default
)

// Product Component
Vue.component(
    "product-list-component",
    require("./page/product/Index.vue").default
);

Vue.component(
    "product-create-component",
    require("./page/product/Create.vue").default
);

Vue.component(
    "example-component",
    require("./page/ExampleComponent.vue").default
);

Vue.component(
    "date-picker-component",
    require("./page/DatePicker.vue").default
);

// Vue.prototype.$formatErrorMessage = errorResponse => {
//     let data = errorResponse.response.data;
//     let ul = document.createElement("ul");
//     ul.setAttribute("class", "pl-2 text-left mb-0");

//     if (data && data.errors) {
//         let errors = Object.values(data.errors).flat();
//         errors.map(e => {
//             var li = document.createElement("li");
//             li.innerHTML = e;
//             ul.appendChild(li);
//         });
//     } else if (data && data.message) {
//         var li = document.createElement("li");
//         li.innerHTML = data.message;
//         ul.appendChild(li);
//     }

//     return ul;
// };
